import { API_ENDPOINTS } from "shared/constants";
import { APIService } from "shared/services";
import {
  IInfoBlock,
  IInfoBlockItem,
  IInfoBlockItemType,
  IJSONAPICollection,
  IJSONAPIItem,
} from "shared/types";
import { IInfoBlockWithPath } from "Venues/types";

interface IJSONAPIInfoBlock {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIInfoBlockCollection {
  [key: string]: IJSONAPIInfoBlock;
  meta: {
    [key: string]: IJSONAPIItem;
  };
}

export class InfoBlockService {
  static getInfoBlockApiPath = (parentType: "stage" | "venue", id?: string) => {
    if (parentType === "stage") {
      return id ? API_ENDPOINTS.STAGE_INFO_BLOCK(id) : API_ENDPOINTS.STAGE_INFO_BLOCKS;
    }
    return id ? API_ENDPOINTS.VENUE_INFO_BLOCK(id) : API_ENDPOINTS.VENUE_INFO_BLOCKS;
  };

  static getInfoBlock = (path: string): Promise<IJSONAPIInfoBlockCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const data = await APIService.get({
          path,
        });

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });

  static mapItemsToIds = (items: IInfoBlockItemType[], type: IInfoBlockItem) =>
    items.map(item => API_ENDPOINTS.INFO_BLOCK_ITEM(item.id, type));

  static createInfoBlock = (data: IInfoBlock): Promise<IJSONAPICollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: InfoBlockService.getInfoBlockApiPath("stage" in data ? "stage" : "venue"),
          data: {
            ...data,
            contacts: InfoBlockService.mapItemsToIds(data?.contacts || [], IInfoBlockItem.contact),
            places: InfoBlockService.mapItemsToIds(data?.places || [], IInfoBlockItem.place),
            files: InfoBlockService.mapItemsToIds(data?.files || [], IInfoBlockItem.file),
            images: InfoBlockService.mapItemsToIds(data?.images || [], IInfoBlockItem.image),
          },
        });

        resolve(response);
      } catch (error) {
        reject(error);
      }
    });

  static editInfoBlock = ({
    path,
    ...data
  }: IInfoBlockWithPath): Promise<IJSONAPIInfoBlockCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.patch({
          path,
          data: {
            ...data,
            contacts: InfoBlockService.mapItemsToIds(data?.contacts || [], IInfoBlockItem.contact),
            places: InfoBlockService.mapItemsToIds(data?.places || [], IInfoBlockItem.place),
            files: InfoBlockService.mapItemsToIds(data?.files || [], IInfoBlockItem.file),
            images: InfoBlockService.mapItemsToIds(data?.images || [], IInfoBlockItem.image),
          },
        });

        resolve(response);
      } catch (error) {
        reject(error);
      }
    });

  static deleteInfoBlock = (path: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path,
        });

        resolve();
      } catch (error) {
        reject(error);
      }
    });
}
